import { AxiosResponse } from 'axios';
import axios from 'axios';
import { InboxNotificationAPI, InboxNotification } from '@/models/inbox-notification';
import { Product, ProductsApi } from '@/api';
import { BehaviorSubject, from } from 'rxjs';

const BASE_URL: string = process.env.VUE_APP_API_URL.replace(/\/+$/, '');

class NotificationService {
	public notifications: BehaviorSubject<InboxNotification[]>;

	constructor() {
		this.notifications = new BehaviorSubject<InboxNotification[]>([]);
	}

	public fetchEventNotifications(): void {
		const notificationsObservable = from(
			axios.get<InboxNotificationAPI[]>(BASE_URL + '/ordway/queueFailures'),
		);
		notificationsObservable.subscribe(
			(notificationsResponse: AxiosResponse<InboxNotificationAPI[]>) => {
				const parsedNotifications = notificationsResponse.data.map(
					(notification: InboxNotificationAPI) => new InboxNotification(notification),
				);
				this.notifications.next(parsedNotifications);
			},
		);
	}

	public async retryNotification(notification: InboxNotification): Promise<void> {
		if (notification.retryEndpointUrl && notification.retryEndpointMethod) {
			switch (notification.retryEndpointMethod) {
				case 'POST': {
					await axios.post(notification.retryEndpointUrl, notification.parameters);
					break;
				}
				case 'PATCH': {
					await axios.patch(notification.retryEndpointUrl, notification.parameters);
					break;
				}
			}
		}
	}

	public async dismissNotification(notificationId: string): Promise<void> {
		await axios.delete(`ordway/queueFailures/${notificationId}`);
		this.fetchEventNotifications();
	}

	public async addProductInfoToNotifications(): Promise<void> {
		this.notifications.value.forEach(async (notification: InboxNotification) => {
			if (!notification.product) {
				const productResponse = await new ProductsApi().getProductById(
					notification.parameters.productId,
					{
						params: {
							include: 'org,site,subscriptionitem',
						},
					},
				);
				notification.product = productResponse.data as Product;
			}
		});
	}
}

export const notificationService = new NotificationService();
